<template>
  <div :class="b()">
    <div :class="b('toolbar')" class="om-hairline-top-bottom" v-if="showToolbar">
      <slot>
        <div :class="b('cancel')" @click="$emit('cancel', result)">{{ cancelButtonText || $t('cancel') }}</div>
        <div :class="b('title')" class="om-ellipsis" v-if="title" v-text="title" />
        <div :class="b('confirm')" @click="$emit('confirm', result)">{{ confirmButtonText || $t('confirm') }}</div>
      </slot>
    </div>
    <div v-if="loading" :class="b('loading')">
      <loader />
    </div>
    <om-checkbox-group v-model="result" :class="b('choices')">
      <om-checkbox
        v-for="(item, index) in choices"
        :key="index"
        :name="item[0]"
      >
        {{ item[1] }}
      </om-checkbox>
    </om-checkbox-group>
  </div>
</template>
<script>
import create from '../utils/create';

export default create({
  name: 'multi-choice',
  props: {
    title: String,
    loading: Boolean,
    showToolbar: { type: Boolean, default: true },
    confirmButtonText: String,
    cancelButtonText: String,
    choices: Array, // [(name, title), (name, title)] => result [name, name, ...]
    value: { type: Array, default() {return []} },
  },
  data() {
    return {
      result: this.value,
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/MultiChoice/index.vue